import { render, staticRenderFns } from "./emptyList.vue?vue&type=template&id=3648fe81&"
import script from "./emptyList.vue?vue&type=script&lang=js&"
export * from "./emptyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports